import { ResponseBase } from '@api/types';

export type Environment = 'local' | 'development' | 'test' | 'prod' | 'test_sf';
export type BankSiteKey = 'bank' | 'district' | 'fieldoffice' | 'noaaregion' | 'state';
export type IlfProgramKey = 'district' | 'fieldoffice' | 'noaaregion' | 'state';

export const bankSiteQueryMap = {
  bank: 'kind_of_bank',
  district: 'district',
  fieldoffice: 'fieldoffice',
  state: 'state',
  noaaregion: 'noaaregion',
};
export const ilfProgramQueryMap = {
  district: 'district',
  fieldoffice: 'fieldoffice',
  state: 'state',
  noaaregion: 'noaaregion',
};

export type CommonRibitsData = {
  id: number;
  value: string;
};
export type CommonRibitsDataList = CommonRibitsData[];

export type BankSite = {
  BANK_ID: number;
  BANK_SITE_DATA_WS_URL: string;
  NAME: string;
};
export type BankSiteList = BankSite[];
export type GetBankSiteListResponse = ResponseBase & {
  data: string;
};

export type IlfProgram = {
  ILF_PROGRAM_DATA_WS_URL: string;
  PROGRAM_ID: number;
  PROGRAM_NAME: string;
};
export type IlfProgramList = IlfProgram[];
export type GetIlfProgramListResponse = ResponseBase & {
  data: string;
};

export type MitigationBankOrIlf = {
  id: string;
  name: string;
  status: string;
  DistrictInd: string;
  ServiceAreaInd: string;
  IsILF: string;
};

export type MitigationBank = {
  name: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: any;
};
